var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3714 1.07152C12.133 0.976159 11.867 0.976159 11.6286 1.07152L1.62861 5.07152C1.24895 5.22339 1 5.5911 1 6V17.5C1 17.8935 1.23078 18.2504 1.58964 18.4119L11.5896 22.9119C11.8506 23.0294 12.1494 23.0294 12.4104 22.9119L22.4104 18.4119C22.7692 18.2504 23 17.8935 23 17.5V6C23 5.5911 22.751 5.22339 22.3714 5.07152L12.3714 1.07152ZM3 15.9534L11 12.3534V10.677L3 7.47703V15.9534ZM11 14.5466L4.43686 17.5L11 20.4534V14.5466ZM13 12.3534L21 15.9534V7.47703L13 10.677V12.3534ZM19.5631 17.5L13 14.5466V20.4534L19.5631 17.5ZM12 8.92297L19.3074 6L12 3.07703L4.69258 6L12 8.92297Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxframe);
export default __webpack_public_path__ + "static/media/boxframe.b011862f6b81a9823e228091b992c8c4.svg";
export { ForwardRef as ReactComponent };